<!-- @format -->

@for (priorLearning of priorLearnings; track priorLearning; let i = $index) {
  <div class="form-group-mimic application-attributes">
    @let externalAttainedStudy = getExternalAttainedStudy(priorLearning);
    @if (showAsExpandable) {
      <sis-expandable [level]="level" [variant]="'naked-dotted'">
        <ng-template sisExpandableCustomTitle>
          <ng-container [ngTemplateOutlet]="title" [ngTemplateOutletContext]="{ priorLearning, externalAttainedStudy, i }"></ng-container>
        </ng-template>
        <ng-template sisExpandableContent>
          <ng-container
            [ngTemplateOutlet]="priorLearningContent"
            [ngTemplateOutletContext]="{ priorLearning, externalAttainedStudy }"></ng-container>
        </ng-template>
      </sis-expandable>
    } @else {
      <div role="heading" class="fudis-heading__lg" [attr.aria-level]="level">
        <ng-container [ngTemplateOutlet]="title" [ngTemplateOutletContext]="{ priorLearning, externalAttainedStudy, i }"></ng-container>
      </div>
      <ng-container
        [ngTemplateOutlet]="priorLearningContent"
        [ngTemplateOutletContext]="{ priorLearning, externalAttainedStudy }"></ng-container>
    }
  </div>
}

<ng-template #priorLearningContent let-priorLearning="priorLearning" let-externalAttainedStudy="externalAttainedStudy">
  @if (externalAttainedStudy) {
    @if (priorLearning.type === PRIOR_LEARNING_TYPE.STUDIES) {
      <sis-prior-studies-summary [priorStudies]="priorLearning" [externalAttainedStudy]="externalAttainedStudy"></sis-prior-studies-summary>
    }
  } @else {
    @if (priorLearning.type === PRIOR_LEARNING_TYPE.STUDIES) {
      <sis-prior-studies-summary [priorStudies]="priorLearning"></sis-prior-studies-summary>
    }
  }
  @if (priorLearning.type === PRIOR_LEARNING_TYPE.COMPETENCE) {
    <sis-prior-competence-summary [priorCompetence]="priorLearning"></sis-prior-competence-summary>
  }
</ng-template>

<ng-template #title let-priorLearning="priorLearning" let-externalAttainedStudy="externalAttainedStudy" let-i="i">
  <div>
    {{ priorLearning | priorLearningName: applicationType : (priorLearnings.length > 1 ? i : null) }}
    @if (externalAttainedStudy) {
      <fudis-badge class="sis-ml-xs" variant="primary"
        >{{ "STUDENT_APPLICATIONS.PRIOR_LEARNING.PRIOR_LEARNING_EMREX_BADGE" | transloco }}
      </fudis-badge>
      <fudis-body-text class="sis-mt-sm" [variant]="'md-light'"
        >{{ "STUDENT_APPLICATIONS.PRIOR_LEARNING.SELECTED_EMREX_ATTAINMENT_GUIDANCE" | transloco }}
      </fudis-body-text>
      <fudis-button
        class="sis-mt-xs"
        [size]="'small'"
        [variant]="'tertiary'"
        [label]="'STUDENT_APPLICATIONS.PRIOR_LEARNING.VIEW_EMREX_ATTAINMENT' | transloco"
        (handleClick)="this.openEmrexAttainmentDialog(externalAttainedStudy)" />
    }
  </div>
</ng-template>
